import styled from 'styled-components';

export const SideBar = styled.div`
  box-sizing: border-box;
  min-height: 100%;
  max-width: 338px;
  min-width: 338px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.02);
  margin: 0px 18px 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 50px;
`;
export const SideBarTitle = styled.h1`
  color: #1b1818;
  font-family: 'Proxima Nova';
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
  text-align: center;
  margin-top: 54px;
  align-self: center;
`;
export const SideBarSubtitle = styled.span`
  display: flex;
  align-self: flex-start;
  color: #5d6c76;
  font-family: 'Proxima Nova';
  font-size: 16px;
  letter-spacing: -0.4px;
  line-height: 24px;
  margin: 10px 0px 5px 0px;
  min-width: max-content;
`;
export const RadiosContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const SideBarLink = styled.span`
  color: #007aff;
  font-family: 'Proxima Nova';
  font-size: 14px;
  font-weight: 300;
  letter-spacing: -0.35px;
  line-height: 24px;
  align-self: center;
  display: inline-flex;
  width: 100%;
  justify-content: flex-end;
  margin: 10px 0px 5px 0px;
  cursor: pointer;
`;
